import {
  APPOINTMENT_SESSION,
  CLEAN_APPOINTMENTS_FILTER,
  CLEAR_IDTURNOS,
  CLEAR_SUPPORT_APPOINTMENTS,
  GET_APPOINTMENT_MODEL,
  GET_APPOINTMENTS_FILTER,
  GET_BRANCH,
  GET_BRANCHES,
  GET_LAST_PROFESSIONAL,
  GET_MAX_APPOINTMENT_DAYS,
  GET_PENDING_APPOINTMENTS,
  GET_SUPPORT_APPOINTMENTS,
  POST_APPOINTMENT,
  POST_ATTENDANCE_QR,
  POST_SESSION,
  REMOVE_APPOINTMENT_FROM_LIST,
} from "../actions/appointments";

const INITIAL_STATE = {
  pendingAppointments: {
    isFetching: false,
    didInvalidate: false,
    list: [],
  },
  appointmentsFilter: {
    isFetching: false,
    didInvalidate: false,
    list: [],
  },
  postAppointment: {
    isFetching: false,
    didInvalidate: false,
    data: {},
  },
  appointmentSession: {
    isFetching: false,
    didInvalidate: false,
    data: {},
  },
  postSession: {
    isFetching: false,
    didInvalidate: false,
    data: {},
  },
  supportAppointments: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  getBranches: {
    isFetching: false,
    didInvalidate: false,
    data: [],
  },
  attendanceQr: {
    isFetching: false,
    didInvalidate: false,
    data: {},
  },
  selectedBranch: { isFetching: false, didInvalidate: false, data: null },
  maxDaysWarning: {
    isFetching: false,
    didInvalidate: false,
    data: null,
  },
  lastProfessional: {
    isFetching: false,
    didInvalidate: false,
    data: {
      profesionalApellidoNombre: "",
      especialidad: "",
      matricula: "",
    },
  },
  formModel: {
    isFetching: false,
    didInvalidate: false,
    data: null,
  }
};

const appointments = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${GET_MAX_APPOINTMENT_DAYS}_REJECTED`:
      return {
        ...state,
        maxDaysWarning: {
          ...state.maxDaysWarning,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_MAX_APPOINTMENT_DAYS}_PENDING`:
      return {
        ...state,
        maxDaysWarning: {
          ...state.maxDaysWarning,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_MAX_APPOINTMENT_DAYS}_FULFILLED`:
      return {
        ...state,
        maxDaysWarning: {
          ...state.maxDaysWarning,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    case `${GET_SUPPORT_APPOINTMENTS}_REJECTED`:
      return {
        ...state,
        supportAppointments: {
          ...state.supportAppointments,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_SUPPORT_APPOINTMENTS}_PENDING`:
      return {
        ...state,
        supportAppointments: {
          ...state.supportAppointments,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_SUPPORT_APPOINTMENTS}_FULFILLED`:
      return {
        ...state,
        supportAppointments: {
          ...state.supportAppointments,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    case CLEAR_SUPPORT_APPOINTMENTS:
      return {
        ...state,
        supportAppointments: INITIAL_STATE.supportAppointments,
      };
    case `${GET_BRANCH}_REJECTED`:
      return {
        ...state,
        selectedBranch: {
          ...state.selectedBranch,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_BRANCH}_PENDING`:
      return {
        ...state,
        selectedBranch: {
          ...state.selectedBranch,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_BRANCH}_FULFILLED`:
      return {
        ...state,
        selectedBranch: {
          ...state.selectedBranch,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    case `${GET_BRANCHES}_REJECTED`:
      return {
        ...state,
        getBranches: {
          ...state.getBranches,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_BRANCHES}_PENDING`:
      return {
        ...state,
        getBranches: {
          ...state.getBranches,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_BRANCHES}_FULFILLED`:
      return {
        ...state,
        getBranches: {
          ...state.getBranches,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    case `${GET_PENDING_APPOINTMENTS}_REJECTED`:
      return {
        ...state,
        pendingAppointments: {
          ...state.pendingAppointments,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_PENDING_APPOINTMENTS}_PENDING`:
      return {
        ...state,
        pendingAppointments: {
          ...state.pendingAppointments,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_PENDING_APPOINTMENTS}_FULFILLED`:
      return {
        ...state,
        pendingAppointments: {
          ...state.pendingAppointments,
          isFetching: false,
          didInvalidate: false,
          list:
            action.payload.data && action.payload.data.appointments
              ? action.payload.data.appointments
              : action.payload.data,
        },
      };

    case `${GET_APPOINTMENTS_FILTER}_REJECTED`:
      return {
        ...state,
        appointmentsFilter: {
          ...state.appointmentsFilter,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${GET_APPOINTMENTS_FILTER}_PENDING`:
      return {
        ...state,
        appointmentsFilter: {
          ...state.appointmentsFilter,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${GET_APPOINTMENTS_FILTER}_FULFILLED`:
      return {
        ...state,
        appointmentsFilter: {
          ...state.appointmentsFilter,
          isFetching: false,
          didInvalidate: false,
          list: action.payload.data.appointments,
        },
      };

    case `${CLEAN_APPOINTMENTS_FILTER}`:
      return {
        ...state,
        appointmentsFilter: {
          ...state.appointmentsFilter,
          isFetching: false,
          didInvalidate: false,
          list: [],
        },
      };

    case `${REMOVE_APPOINTMENT_FROM_LIST}`:
      const appointmentIdToRemove = action.payload.data.appointmentIdToRemove;
      const newPendingAppointmentsList = state.pendingAppointments.list.filter(
        (appointment) => appointment.id !== appointmentIdToRemove,
      );
      const newAppointmentsFilterList = state.appointmentsFilter.list.filter(
        (appointment) => appointment.id !== appointmentIdToRemove,
      );

      return {
        ...state,
        pendingAppointments: {
          ...state.pendingAppointments,
          list: newPendingAppointmentsList,
        },
        appointmentsFilter: {
          ...state.appointmentsFilter,
          list: newAppointmentsFilterList,
        },
      };
    case `${POST_APPOINTMENT}_REJECTED`:
      return {
        ...state,
        postAppointment: {
          ...state.postAppointment,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${POST_APPOINTMENT}_PENDING`:
      return {
        ...state,
        postAppointment: {
          ...state.postAppointment,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${POST_APPOINTMENT}_FULFILLED`: {
      return {
        ...state,
        postAppointment: {
          ...state.postAppointment,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${APPOINTMENT_SESSION}_REJECTED`:
      return {
        ...state,
        appointmentSession: {
          ...state.appointmentSession,
          data: [],
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${APPOINTMENT_SESSION}_PENDING`:
      return {
        ...state,
        appointmentSession: {
          ...state.appointmentSession,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${APPOINTMENT_SESSION}_FULFILLED`: {
      return {
        ...state,
        appointmentSession: {
          ...state.appointmentSession,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }
    case `${POST_SESSION}_REJECTED`:
      return {
        ...state,
        postSession: {
          ...state.postSession,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${POST_SESSION}_PENDING`:
      return {
        ...state,
        postSession: {
          ...state.postSession,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${POST_SESSION}_FULFILLED`: {
      return {
        ...state,
        postSession: {
          ...state.postSession,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }

    case `${POST_ATTENDANCE_QR}_REJECTED`:
      return {
        ...state,
        attendanceQr: {
          ...state.attendanceQr,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${POST_ATTENDANCE_QR}_PENDING`:
      return {
        ...state,
        attendanceQr: {
          ...state.attendanceQr,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${POST_ATTENDANCE_QR}_FULFILLED`: {
      return {
        ...state,
        attendanceQr: {
          ...state.attendanceQr,
          isFetching: false,
          didInvalidate: false,
        },
      };
    }

    case `${GET_LAST_PROFESSIONAL}_REJECTED`: {
      return {
        ...state,
        lastProfessional: {
          ...state.lastProfessional,
          isFetching: false,
          didInvalidate: true,
        },
      };
    }
    case `${GET_LAST_PROFESSIONAL}_PENDING`: {
      return {
        ...state,
        lastProfessional: {
          ...state.lastProfessional,
          isFetching: true,
          didInvalidate: false,
        },
      };
    }
    case `${GET_LAST_PROFESSIONAL}_FULFILLED`: {
      return {
        ...state,
        lastProfessional: {
          ...state.lastProfessional,
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        },
      };
    }

    case CLEAR_IDTURNOS: {
      return {
        ...state,
        postSession: {
          data: [],
        },
        postAppointment: {
          data: [],
        },
      };
    }

    case `${GET_APPOINTMENT_MODEL}_REJECTED`:
      return {
        ...state,
        formModel: {
          isFetching: false,
          didInvalidate: true,
        }
      };
    case `${GET_APPOINTMENT_MODEL}_PENDING`:
      return {
        ...state,
        formModel: {
          isFetching: true,
          didInvalidate: false,
        }
      };
    case `${GET_APPOINTMENT_MODEL}_FULFILLED`:
      return {
        ...state,
        formModel: {
          isFetching: false,
          didInvalidate: false,
          data: action.payload.data,
        }
      };

    default:
      return state;
  }
};

export default appointments;
